import styled, { css } from 'styled-components';
import { Theme } from '@/theme';

type ButtonAttributes = {
  disabled?: boolean;
  margin?: string;
  width?: string;
};

export const ButtonPrimary = styled.button(
  ({ disabled, margin = '', width = '100%' }: ButtonAttributes) => css`
    transition: background-color 0.3s, border-color 0.3s, color 0.3s;
    box-shadow: 0px -5px 0px 0px rgba(0 0 0 / 0.3) inset;

    background-color: ${Theme.color.orange};
    border: 3px solid ${Theme.color.brown};

    font-size: ${Theme.rems(16)};
    backface-visibility: hidden;
    color: ${Theme.color.brown};
    letter-spacing: normal;

    border-radius: 40px;
    padding: 10px 40px;
    text-align: center;
    position: relative;

    margin: ${margin};
    line-height: 1.5;
    font-weight: 700;

    cursor: pointer;
    width: ${width};

    display: block;
    height: 60px;

    ${disabled &&
    css`
      background-color: ${Theme.color.disabledBg} !important;
      border-color: ${Theme.color.disabled} !important;

      color: ${Theme.color.disabled};
      pointer-events: none;

      > svg path {
        fill: ${Theme.color.disabled};
      }
    `}
  `
);

export const ButtonSecondary = styled(ButtonPrimary)`
  background-color: ${Theme.color.white};
`;

export const ButtonIconFill = styled(ButtonPrimary)`
  box-shadow: 0px -3px 0px 0px rgba(0 0 0 / 0.3) inset;
  border-color: ${Theme.color.white};

  justify-content: center;
  padding: 5px 5px 7.5px;

  display: inline-flex;
  align-items: center;
  border-width: 2px;

  height: 40px;
  width: 40px;

  > svg {
    height: auto;
    width: 20px;
  }
`;

export const ButtonIcon = styled(ButtonIconFill)`
  background-color: ${Theme.color.white};
  border-color: ${Theme.color.brown};
`;
